import { styled } from '@mui/material/styles';
import { Box, Button, Typography } from '@mui/material';
import { ThemePalette } from 'mui.theme';
import useAppTheme from 'hooks/useAppTheme';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

const _palette = clientThemePalette[CLIENT_THEME];

export const StyledTypography = styled(Typography)(() => {
  const { enableDarkTheme } = useAppTheme();
  return {
    color: (enableDarkTheme ? _palette.dark : _palette.light).textPrimary,
    fontWeight: 'bold',
    transition: 'all 0.3s ease-in-out',
  };
});

export const StyledBox = styled(Box)(() => {
  const { enableDarkTheme } = useAppTheme();
  return {
    backgroundColor: enableDarkTheme
      ? _palette.dark.boxBackground
      : _palette.light.boxBackground,
    borderRadius: '5px',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.3s ease-in-out',
    padding: '10px',
    width: '100%',
    boxSizing: 'border-box',
  };
});

export const SubText = styled('span')(() => {
  const { enableDarkTheme } = useAppTheme();
  return {
    color: (enableDarkTheme ? _palette.dark : _palette.light).textPrimary,
    fontWeight: 'normal',
    transition: 'all 0.3s ease-in-out',
    fontSize: '11px',
  };
});

export const FlexBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'all 0.3s ease-in-out',
  height: '100%',
  boxSizing: 'border-box',
  gap: '2px',
});

export const StyledFlexBox = styled(StyledBox)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'all 0.3s ease-in-out',
  height: '100%',
  boxSizing: 'border-box',
  gap: 2,
});

export const StyledButton = styled(Button)(({ theme }) => {
  const { enableDarkTheme } = useAppTheme();
  return {
    padding: '6px 16px',
    borderRadius: '4px',
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '14px',
    backgroundColor: enableDarkTheme
      ? _palette.dark.primary
      : _palette.light.primary,
    color: ThemePalette.typography.white,
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: enableDarkTheme
        ? _palette.dark.primaryDark
        : _palette.light.primaryDark,
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
    },
    '&:active': {
      backgroundColor: enableDarkTheme
        ? _palette.dark.primaryDark
        : _palette.light.primaryDark,
      boxShadow: '0 1px 4px rgba(0, 0, 0, 0.1)',
    },
    '&:disabled': {
      backgroundColor: enableDarkTheme
        ? 'rgba(255, 255, 255, 0.12)'
        : 'rgba(0, 0, 0, 0.12)',
      color: enableDarkTheme
        ? 'rgba(255, 255, 255, 0.38)'
        : 'rgba(0, 0, 0, 0.38)',
    },
  };
});
